/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as OfflineStatusImport } from './routes/offline-status'
import { Route as IndexImport } from './routes/index'
import { Route as OfflineStatusRegionsImport } from './routes/offline-status.regions'
import { Route as OfflineStatusRegionsIndexImport } from './routes/offline-status.regions.index'
import { Route as OfflineStatusRegionsRegionIdImport } from './routes/offline-status.regions.$regionId'
import { Route as OfflineStatusRegionsRegionIdLocalitiesImport } from './routes/offline-status.regions.$regionId_.localities'
import { Route as OfflineStatusRegionsRegionIdLocalitiesLocalityIdImport } from './routes/offline-status.regions.$regionId_.localities.$localityId'
import { Route as OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport } from './routes/offline-status.regions.$regionId_.localities.$localityId_.locations'
import { Route as OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport } from './routes/offline-status.regions.$regionId_.localities.$localityId_.locations.$locationId'

// Create/Update Routes

const OfflineStatusRoute = OfflineStatusImport.update({
  path: '/offline-status',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const OfflineStatusRegionsRoute = OfflineStatusRegionsImport.update({
  path: '/regions',
  getParentRoute: () => OfflineStatusRoute,
} as any)

const OfflineStatusRegionsIndexRoute = OfflineStatusRegionsIndexImport.update({
  path: '/',
  getParentRoute: () => OfflineStatusRegionsRoute,
} as any)

const OfflineStatusRegionsRegionIdRoute =
  OfflineStatusRegionsRegionIdImport.update({
    path: '/$regionId',
    getParentRoute: () => OfflineStatusRegionsRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesRoute =
  OfflineStatusRegionsRegionIdLocalitiesImport.update({
    path: '/$regionId/localities',
    getParentRoute: () => OfflineStatusRegionsRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesLocalityIdRoute =
  OfflineStatusRegionsRegionIdLocalitiesLocalityIdImport.update({
    path: '/$localityId',
    getParentRoute: () => OfflineStatusRegionsRegionIdLocalitiesRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsRoute =
  OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport.update({
    path: '/$localityId/locations',
    getParentRoute: () => OfflineStatusRegionsRegionIdLocalitiesRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdRoute =
  OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport.update(
    {
      path: '/$locationId',
      getParentRoute: () =>
        OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/offline-status': {
      preLoaderRoute: typeof OfflineStatusImport
      parentRoute: typeof rootRoute
    }
    '/offline-status/regions': {
      preLoaderRoute: typeof OfflineStatusRegionsImport
      parentRoute: typeof OfflineStatusImport
    }
    '/offline-status/regions/$regionId': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdImport
      parentRoute: typeof OfflineStatusRegionsImport
    }
    '/offline-status/regions/': {
      preLoaderRoute: typeof OfflineStatusRegionsIndexImport
      parentRoute: typeof OfflineStatusRegionsImport
    }
    '/offline-status/regions/$regionId/localities': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesImport
      parentRoute: typeof OfflineStatusRegionsImport
    }
    '/offline-status/regions/$regionId/localities/$localityId': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdImport
      parentRoute: typeof OfflineStatusRegionsRegionIdLocalitiesImport
    }
    '/offline-status/regions/$regionId/localities/$localityId/locations': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport
      parentRoute: typeof OfflineStatusRegionsRegionIdLocalitiesImport
    }
    '/offline-status/regions/$regionId/localities/$localityId/locations/$locationId': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport
      parentRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  OfflineStatusRoute.addChildren([
    OfflineStatusRegionsRoute.addChildren([
      OfflineStatusRegionsRegionIdRoute,
      OfflineStatusRegionsIndexRoute,
      OfflineStatusRegionsRegionIdLocalitiesRoute.addChildren([
        OfflineStatusRegionsRegionIdLocalitiesLocalityIdRoute,
        OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsRoute.addChildren(
          [
            OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdRoute,
          ],
        ),
      ]),
    ]),
  ]),
])

/* prettier-ignore-end */
